import { Button } from "react-bootstrap";
import { useProfile } from "../components/ProfileContext"
import { emptyArray, setNavAdvisoryLockout, useForceRender } from "../util/utils";
import { useEffect, useState } from "react";

export function DebugPage(props) {
	setNavAdvisoryLockout(false);

	let [profile, setProfile] = useProfile();
	let render = useForceRender();
	let [cameras, setCameras] = useState(null);
	
	useEffect(async () => {
		if(cameras == null) {
			// setCameras(await Html5Qrcode.getCameras());
		}
	});
	return (
		<div className="debugPageContainer">
			<h1>Debug Page</h1>
			<ul>
				<li>User ID: {profile.id}</li>
				<li>Username: {profile.userName} </li>
				<li>Token: {profile?.token || "None"} <Button onClick={() => {profile.token = "asdf"; render(); }}>Fail Token</Button></li>
				<li>Full Record: {JSON.stringify(profile)}</li>
				<li>Cameras:
					{cameras == null && "Loading"}
					{cameras != null && <ul>
						{cameras.map((cam, idx) => <li key={idx}>
							{JSON.stringify(cam)}
						</li>)}
					</ul>}
				</li>
			</ul>
		</div>
	)
}